module.exports = __webpack_public_path__ + "static/media/pedagonet.cc171809.png";